// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"a88fea2e","608":"6b99cffd","616":"8434d725","895":"1404109b"}[chunkId] + ".chunk.js";
};